"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const core_1 = require("@material-ui/core");
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importStar(require("react"));
const TooltipIcon_1 = __importDefault(require("../TooltipIcon"));
const makeMyClasses = (label, labelPlacement, tiny, small, loading, color, colorizeLabel) => ({
    root: {
        width: tiny ? 20 : small ? 31 : 48,
        height: tiny ? 12 : small ? 16 : 24,
        padding: 0,
        margin: label ? (labelPlacement === 'start' ? '0 0 0 8px' : '0 8px 0 0') : 0,
    },
    switchBase: {
        padding: 1,
        transform: loading ? (small ? 'translateX(7.5px)' : 'translateX(12px)') : '',
        '&.Mui-checked': {
            transform: loading
                ? tiny
                    ? 'translateX(4px)'
                    : small
                        ? 'translateX(7.5px)'
                        : 'translateX(12px)'
                : tiny
                    ? 'translateX(8px)'
                    : small
                        ? 'translateX(15px)'
                        : 'translateX(24px)',
            '& + .MuiSwitch-track': {
                backgroundColor: loading ? lib_palette_1.default.LavendarGrey.main : color.main,
                opacity: 1,
            },
        },
        '&.Mui-disabled': {
            color: '#fff',
            opacity: '0.8 !important',
            '& + .MuiSwitch-track': {
                opacity: '0.4 !important',
            },
        },
    },
    thumb: {
        width: tiny ? 8 : small ? 14 : 22,
        height: tiny ? 8 : small ? 14 : 22,
        margin: tiny ? 1 : 0,
        boxShadow: 'none',
    },
    track: {
        borderRadius: 12,
        opacity: 1,
        backgroundColor: lib_palette_1.default.LavendarGrey.main,
    },
    label: {
        transition: 'color 0.3s',
        color: colorizeLabel && color ? color.dark : undefined,
        alignItems: labelPlacement === 'end' ? 'start' : undefined,
        '& .MuiFormControlLabel-label': labelPlacement === 'end'
            ? {
                paddingTop: 4,
            }
            : undefined,
    },
});
function Switch(props) {
    const { label, tip, labelPlacement = 'end', loading = false, color = lib_palette_1.default.positive, checked = true, onChange = doNothing_1.default, small = false, tiny = false, disabled = false, colorizeLabel = false, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [
        label,
        labelPlacement,
        tiny,
        small,
        loading,
        color,
        colorizeLabel,
    ]);
    const handleChange = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    }, [checked, onChange]);
    const control = (react_1.default.createElement(core_1.Switch, { color: "default", checked: checked, onClick: e => e.stopPropagation(), onChange: handleChange, disabled: disabled || loading, classes: {
            root: myCss.root + ' newStyle',
            switchBase: myCss.switchBase + ' newStyle',
            thumb: myCss.thumb + ' newStyle',
            track: myCss.track + ' newStyle',
        } }));
    if (label) {
        let labelText = label;
        if (tip)
            labelText = (react_1.default.createElement(Horizontal_1.default, { gutter: true },
                label,
                react_1.default.createElement(TooltipIcon_1.default, { tip: tip })));
        return (react_1.default.createElement(core_1.FormControlLabel, { className: myCss.label, labelPlacement: labelPlacement, control: control, label: labelText }));
    }
    return control;
}
exports.Switch = Switch;
exports.default = Switch;
